import { useQuery } from '@tanstack/react-query';
import { getMethodologies } from 'api/methodologies';
import { methodologiesKeys } from 'api/queryKeys';

export const useMethodologiesQuery = () => {
  return useQuery({
    queryKey: methodologiesKeys.all(),
    queryFn: () => getMethodologies().then((res) => res.data ?? [])
  });
};
